<div>
    <h2 mat-dialog-title class="cut-long-text">
        @if (!data?.id) {
            Neuer Datensatz
        } @else {
            Datensatz bearbeiten
        }
    </h2>
    <mat-divider></mat-divider>

    <form [formGroup]="formGroup" class="sequence-form">
        <mat-tab-group>
            <mat-tab label="Sequenz">
                <mat-dialog-content class="grid">
            <mat-form-field class="full-width">
                <mat-label>Name</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="name"
                />
                <mat-error>{{
                    checkForErrors(formGroup.controls["name"])
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Konsument</mat-label>
                <mat-select formControlName="consumers">
                    @for (consumer of consumers$ | async; track consumer.id) {
                        <mat-option [value]="consumer.id">{{
                            consumer.name
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Fach/Beruf</mat-label>
                <mat-select formControlName="subjects">
                    @for (subject of subjects$ | async; track subject.id) {
                        <mat-option [value]="subject.id">{{
                            subject.name
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <div class="full-width">
                <pixl-state-cb
                    [required]="true"
                    [initValue]="this.data?.approval || ''"
                    (onStateChange)="statusChanged($event)"
                />
            </div>

            <div
                cdkDropList
                class="full-width"
                (cdkDropListDropped)="reorderBlocks($event)"
            >
            @for (seqList of formGroup.get('sequence')?.value.list; let blockIndex = $index; track blockIndex) {
                <div class="full-width" cdkDrag>
                    <div class="border-area full-width">
                        <div class="drag-row">
                            <div class="drag-icon-container">
                                <mat-icon>drag_indicator</mat-icon>
                            </div>
                            <div class="content-column">
                                <b>{{ getBlockName(blockIndex) }} {{ blockIndex + 1 }}</b>
                                <div class="select mt-2 full-width">
                                    <pixl-multi-combo-entity-search
                                        [label]="'Übungsaufgaben'"
                                        [placeHolder]="getPlaceholder()"
                                        [observable$]="exerciseSearchResultObservables[blockIndex]"
                                        [namingColumn]="'name'"
                                        [externalSearch]="true"
                                        (onStateChange)="receiveExerciseStateChange($event, blockIndex)"
                                        (onSearchChange)="receiveExerciseSearchQuery($event, blockIndex)"
                                        (scrolledToEnd)="loadMoreExercises($event, blockIndex)"
                                        [(selectedValues)]="splitSelectedExercises[blockIndex]"
                                        />
                                </div>
                                <div class="select mt-2 full-width">
                                    <pixl-multi-combo-entity-search
                                        [label]="'Erkläreinheiten'"
                                        [placeHolder]="getPlaceholder()"
                                        [observable$]="explanationSearchResultObservables[blockIndex]"
                                        [namingColumn]="'name'"
                                        [externalSearch]="true"
                                        (onStateChange)="receiveExplanationStateChange($event, blockIndex)"
                                        (onSearchChange)="receiveExplanationSearchQuery($event, blockIndex)"
                                        (scrolledToEnd)="loadMoreExplanations($event, blockIndex)"
                                        [(selectedValues)]="splitSelectedExplanations[blockIndex]"
                                        />
                                </div>

                                <div class="mb-1 full-width">Anordnen (Drag'n Drop)</div>
                                <div
                                    cdkDropList
                                    class="list"
                                    (cdkDropListDropped)="reorderExernations($event, blockIndex)"
                                >
                                    @for (
                                        exernation of seqList;
                                        track exernation.id
                                    ) {
                                        <div class="box" cdkDrag>
                                            <div class="left">
                                                @if (exernation.type === "exercise") {
                                                    <mat-icon>edit_square</mat-icon>
                                                    {{ getExerciseName(exernation.id) || 'Lade...'}}
                                                } @else {
                                                    <mat-icon>privacy_tip</mat-icon>
                                                    {{ getExplanationName(exernation.id) || 'Lade...'}}
                                                }
                                            </div>
                                            <button
                                                class="badge"
                                                [ngClass]="getStateColor(exernation)"
                                            >
                                                {{ getStateText(exernation) || 'Dormant' | transloco}}
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            </div>
            <button mat-stroked-button class="full-width" (click)="addExerciseBlock()">Neuen Block hinzufügen</button>

        </mat-dialog-content>
            </mat-tab>
            <mat-tab [label]="(selectedConsumerName$ | async) || 'Metadaten'">
                <mat-dialog-content class="grid">
                    <pixl-object-consumer-metadata [parentForm]="formGroup" [objectType]="'exerciseSequence'"></pixl-object-consumer-metadata>
                </mat-dialog-content>
            </mat-tab>
        </mat-tab-group>
    </form>
    <mat-divider></mat-divider>

    <mat-dialog-actions>
        <button mat-raised-button (click)="onCancel()">Abbruch</button>
        <button
            mat-raised-button
            (click)="onSave()"
            [disabled]="
                !formGroup.valid || formGroup.controls['name'].value === ''
            "
        >
            Speichern
        </button>
    </mat-dialog-actions>
</div>
